import { useCallback } from 'react'
import { InView } from 'react-intersection-observer'
import { debounce } from 'lodash'
import { usePinnedPostsContext } from 'src/context/pinnedPosts'
import { PostCardSkeleton } from '../postCardSkeleton'
import { Card, Header } from './components'
import { Wrapper } from './pinnedPostsSidebar.styles'

const PinnedPostsSidebar = () => {
  const {
    pinnedPosts,
    size,
    pinnedPostsQuery: { isLoading, isSuccess, isFetchingNextPage, hasNextPage, fetchNextPage }
  } = usePinnedPostsContext()

  const handleFetchNextPagePostsDebounce = useCallback(
    debounce(
      /* istanbul ignore next */ (inView: boolean) => {
        if (inView) fetchNextPage?.()
      },
      500
    ),
    []
  )

  const showInViewComponent = hasNextPage && (!isFetchingNextPage || !isLoading)

  return (
    <Wrapper className="_position-absolute _overflow-y-auto">
      <Header pinnedPostsLength={size} />

      {isLoading && <PostCardSkeleton className="_px-5" length={2} isProfile />}

      {isSuccess && pinnedPosts?.map((post) => <Card key={post.id} post={post} borderBottom />)}

      {showInViewComponent && (
        <InView as="div" onChange={handleFetchNextPagePostsDebounce}>
          <PostCardSkeleton className="_px-5" isProfile />
        </InView>
      )}
    </Wrapper>
  )
}

export default PinnedPostsSidebar
